// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  border-size: 0;
  padding: 0;
  margin: 0;
}

body {
  background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/css/main.scss"],"names":[],"mappings":"AAGA;EACI,cAAA;EACA,UAAA;EACA,SAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ","sourcesContent":["$primary-color:#24a8cc;\n$secondary-color:#f4f4f4;\n\n*{\n    border-size: 0;\n    padding: 0;\n    margin: 0;\n}\n\nbody{\n    background-color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
